import {
  showModalDialog, currentDialog, modalDialogs, isAllErbModalsClosed,
  showModal, showConfirmationDialog, dialogCloseModal, registerOpenDialog, loadModal, resetDialogs
} from 'tfx-common/store/dialogs'

export default {
  namespaced: true,
  getters: {
    showModalDialog: (state, getters) => {
      return showModalDialog.value
    },
    currentDialog: (state, getters) => {
      return currentDialog.value
    },
    modalDialogs: (state, getters) => {
      return modalDialogs.value
    },
    isAllErbModalsClosed: () => {
      return isAllErbModalsClosed.value
    }
  },
  actions: {
    showModal({state, commit, rootState}, props) {
      showModal(props)
    },

    showConfirmationDialog({state, dispatch, rootState}, {messages, onClose}) {
      showConfirmationDialog({messages, onClose})
    },

    dialogCloseModal: ({state, commit, rootState}) => {
      dialogCloseModal()
    },

    registerOpenDialog: ({state, dispatch}, {el}) => {
      registerOpenDialog({el})
    },

    loadModal: ({state, dispatch}, {el, closeAll, alert, callback}) => {
      loadModal({el, closeAll, alert, callback})
    },

    resetDialogs() {
      resetDialogs()
    }
  }
}
